import { NCFileDetailsScreen, NCFileDetailsScreenLink, NCFileLevelSubScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { NcFileBatchEventsLink, NcFileBatchEventType } from '@v2/pages/common/enums';
import { createLevelSubScreenLinking } from '@v2/pages/common/helpers';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { NCFileDetailsBatchNavigator } from './NCFileDetailsBatchNavigator';
import { NCFileDetailsJobNavigator } from './NCFileDetailsJobNavigator';
import { NCFileDetailsNCFileNavigator } from './NCFileDetailsNCFileNavigator';
import { NCFileDetailsPartNavigator } from './NCFileDetailsPartNavigator';
import { NCFileDetailsToolNavigator } from './NCFileDetailsToolNavigator';
import { NCFileDetailsPart, NCFileDetailsPartDocuments, NCFileDetailsPartTimeline } from '@v2/pages/nc-file/details/modules/part';
import { timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalArrayItems } from '@helpers';

import {
  NCFileDetailsBatchEventsActive,
  NCFileDetailsBatchEventsChange,
  NCFileDetailsBatchEventsCycle,
  NCFileDetailsBatchEventsNavigator,
  NCFileDetailsBatchEventsSetup,
  NCFileDetailsBatchEventsTrace,
  NCFileDetailsBatch,
  NCFileDetailsBatchDocuments,
  NCFileDetailsBatchTimeline,
} from '../modules/batch';
import {
  NCFileDetailsNCFileEventsActive,
  NCFileDetailsNCFileEventsChange,
  NCFileDetailsNCFileEventsCycle,
  NCFileDetailsNCFileEventsNavigator,
  NCFileDetailsNCFileEventsSetup,
  NCFileDetailsNCFileEventsTrace,
  NCFileDetailsNCFile,
  NCFileDetailsNCFileDocuments,
  NCFileDetailsNCFileLinks,
  NCFileDetailsNCFilePerformanceActive,
  NCFileDetailsNCFilePerformanceNavigator,
  NCFileDetailsNCFilePerformancePaid,
  NCFileDetailsNCFilePerformanceProductive,
  NCFileDetailsNCFilePerformanceUtilization,
  NCFileDetailsNCFileTimeline,
  NCFileDetailsNCFileTimes,
  NCFileDetailsNCFileTraceability,
  NCFileDetailsNCFileVersions,
} from '../modules/nc-file';
import { NCFileDetailsJobs, NCFileDetailsJobsDocuments, NCFileDetailsJobsTimeline } from '@v2/pages/nc-file/details/modules/jobs';

import { BatchLevelSubScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { NCFileDetailsTools } from '@v2/pages/nc-file/details/modules/tools/NCFileDetailsTools';
import {
  filteredBatchLevelSubScreen,
  filteredBatchLevelSubScreenLink,
  filteredJobLevelSubScreen,
  filteredJobLevelSubScreenLink,
  filteredNCFileLevelSubScreen,
  filteredNCFileLevelSubScreenLink,
  filteredPartLevelSubScreen,
  filteredPartLevelSubScreenLink,
} from '../../../common/constants/base.constants';
import { ToolLevelSubScreen, ToolLevelSubScreenLink } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { PartLevelSubScreen } from '@v2/pages/part/details/common/enums/partDetails.enum';
import { JobLevelSubScreen } from '@v2/pages/job/common/enums/jobDetails.enum';

export const NCFileDetailsScreenName = 'NCFileDetailsV2';

export const ncFileDetailsLinking = {
  path: 'nc-file/details',
  screens: {
    [NCFileDetailsScreen.PART]: {
      path: NCFileDetailsScreenLink.PART,
      screens: createLevelSubScreenLinking(NCFileDetailsScreen.PART, {
        levels: filteredPartLevelSubScreen,
        links: filteredPartLevelSubScreenLink,
      }),
    },
    [NCFileDetailsScreen.BATCH]: {
      path: NCFileDetailsScreenLink.BATCH,
      screens: createLevelSubScreenLinking(NCFileDetailsScreen.BATCH, {
        levels: filteredBatchLevelSubScreen,
        links: filteredBatchLevelSubScreenLink,
        nestedScreens: {
          [BatchLevelSubScreen.TIMES]: {
            screenName: BatchLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [NCFileDetailsScreen.NC_FILE]: {
      path: NCFileDetailsScreenLink.NC_FILE,
      screens: createLevelSubScreenLinking(NCFileDetailsScreen.NC_FILE, {
        levels: filteredNCFileLevelSubScreen,
        links: filteredNCFileLevelSubScreenLink,
        nestedScreens: {
          [NCFileLevelSubScreen.TIMES]: {
            screenName: NCFileLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [NCFileDetailsScreen.JOBS]: {
      path: NCFileDetailsScreenLink.JOBS,
      screens: createLevelSubScreenLinking(NCFileDetailsScreen.JOBS, {
        levels: filteredJobLevelSubScreen,
        links: filteredJobLevelSubScreenLink,
      }),
    },
    [NCFileDetailsScreen.TOOLS]: {
      path: NCFileDetailsScreenLink.TOOLS,
      screens: createLevelSubScreenLinking(NCFileDetailsScreen.TOOLS, {
        levels: ToolLevelSubScreen,
        links: ToolLevelSubScreenLink,
      }),
    },
  },
};

export const ncFileDetailsConfig = [
  { name: NCFileDetailsScreen.PART, Component: NCFileDetailsPartNavigator },
  { name: NCFileDetailsScreen.BATCH, Component: NCFileDetailsBatchNavigator },
  { name: NCFileDetailsScreen.NC_FILE, Component: NCFileDetailsNCFileNavigator },
  { name: NCFileDetailsScreen.JOBS, Component: NCFileDetailsJobNavigator },
  { name: NCFileDetailsScreen.TOOLS, Component: NCFileDetailsToolNavigator },
];

export const ncFileDetailsPartConfig = [
  {
    name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.GENERAL}`,
    Component: NCFileDetailsPart,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.TIMELINE}`,
    Component: NCFileDetailsPartTimeline,
  }),
  // {
  //   name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.TIMES}`,
  //   Component: NCFileDetailsPart,
  // },
  // {
  //   name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.PERFORMANCE}`,
  //   Component: NCFileDetailsPartPerformanceNavigator,
  // },
  // {
  //   name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.VERSIONS}`,
  //   Component: NCFileDetailsPart,
  // },
  // {
  //   name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.LINKS}`,
  //   Component: NCFileDetailsPart,
  // },
  {
    name: `${NCFileDetailsScreen.PART}${PartLevelSubScreen.DOCUMENTS}`,
    Component: NCFileDetailsPartDocuments,
  },
];

export const ncFileDetailsToolConfig = [
  {
    name: `${NCFileDetailsScreen.TOOLS}${ToolLevelSubScreen.GENERAL}`,
    Component: NCFileDetailsTools,
  },
];

export const ncFileDetailsBatchConfig = [
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.GENERAL}`,
    Component: NCFileDetailsBatch,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMELINE}`,
    Component: NCFileDetailsBatchTimeline,
  }),
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
    Component: NCFileDetailsBatchEventsNavigator,
  },
  // {
  //   name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.VERSIONS}`,
  //   Component: NCFileDetailsBatch,
  // },
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.DOCUMENTS}`,
    Component: NCFileDetailsBatchDocuments,
  },
];

export const ncFileDetailsNCFileConfig = [
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.GENERAL}`,
    Component: NCFileDetailsNCFile,
  },
  // Based on task SF-4963
  // ...injectConditionalArrayItems(timelineAvailable, {
  //   name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMELINE}`,
  //   Component: NCFileDetailsNCFileTimeline,
  // }),
  // {
  //   name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
  //   Component: NCFileDetailsNCFileTimes,
  // },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
    Component: NCFileDetailsNCFileEventsNavigator,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}`,
    Component: NCFileDetailsNCFilePerformanceNavigator,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.VERSIONS}`,
    Component: NCFileDetailsNCFileVersions,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.LINKS}`,
    Component: NCFileDetailsNCFileLinks,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.DOCUMENTS}`,
    Component: NCFileDetailsNCFileDocuments,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TRACEABILITY}`,
    Component: NCFileDetailsNCFileTraceability,
  }
];

export const ncFileDetailsJobsConfig = [
  {
    name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.GENERAL}`,
    Component: NCFileDetailsJobs,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.TIMELINE}`,
    Component: NCFileDetailsJobsTimeline,
  }),
  // {
  //   name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.TIMES}`,
  //   Component: NCFileDetailsJobs,
  // },
  // {
  //   name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.PERFORMANCE}`,
  //   Component: NCFileDetailsJobsPerformanceNavigator,
  // },
  // {
  //   name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.VERSIONS}`,
  //   Component: NCFileDetailsJobs,
  // },
  // {
  //   name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.LINKS}`,
  //   Component: NCFileDetailsJobs,
  // },
  {
    name: `${NCFileDetailsScreen.JOBS}${JobLevelSubScreen.DOCUMENTS}`,
    Component: NCFileDetailsJobsDocuments,
  },
];

export const ncFilePerformanceConfig = [
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.active}`,
    Component: NCFileDetailsNCFilePerformanceActive,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.productive}`,
    Component: NCFileDetailsNCFilePerformanceProductive,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.paid}`,
    Component: NCFileDetailsNCFilePerformancePaid,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.utilization}`,
    Component: NCFileDetailsNCFilePerformanceUtilization,
  },
];

export const ncFileEventsConfig = [
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: NCFileDetailsNCFileEventsCycle,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: NCFileDetailsNCFileEventsActive,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: NCFileDetailsNCFileEventsChange,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: NCFileDetailsNCFileEventsSetup,
  },
  {
    name: `${NCFileDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: NCFileDetailsNCFileEventsTrace,
  },
];

export const batchEventsConfig = [
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: NCFileDetailsBatchEventsCycle,
  },
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: NCFileDetailsBatchEventsActive,
  },
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: NCFileDetailsBatchEventsChange,
  },
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: NCFileDetailsBatchEventsSetup,
  },
  {
    name: `${NCFileDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: NCFileDetailsBatchEventsTrace,
  },
];
